exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".thead__RDWandHistoryCard-module___Ul3-2 {\n  font-size: 12px;\n}\n.table__RDWandHistoryCard-module___AL7-O {\n  width: 334px;\n}\n.containerTable__RDWandHistoryCard-module___2ZCcH {\n  overflow-y: auto;\n}\n\n@media (max-width: 375px) {\n  .card__RDWandHistoryCard-module___3Oceu {\n    min-width: 260px;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"thead": "thead__RDWandHistoryCard-module___Ul3-2",
	"table": "table__RDWandHistoryCard-module___AL7-O",
	"containerTable": "containerTable__RDWandHistoryCard-module___2ZCcH",
	"card": "card__RDWandHistoryCard-module___3Oceu"
};